import { render } from "./ButtonsGroup.vue?vue&type=template&id=6f6d05c8&scoped=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"

import "./ButtonsGroup.vue?vue&type=style&index=0&id=6f6d05c8&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6d05c8"]])

export default __exports__